import React from "react";
import { IModule } from "../types";
import { ITrustPilotPanelProps, TrustpilotPanel } from "../../../components/panels/TrustpilotPanel";
import { TrustpilotWithReviewsPanel } from "../../../components/panels/TrustpilotWithReviewsPanel";

export type GetTrustPilotPanelProps = IModule<ITrustPilotPanelProps>;

export const getTrustPilotPanel = ({
  id,
  header,
  headerAlignment = "Center",
  noPaddingBottom,
  variant,
  customerReviews,
}: GetTrustPilotPanelProps) => {
  if (variant === "customer reviews") {
    const content = JSON.parse(customerReviews!.internal.content || "{}");

    if (!content.reviews || !content.reviews.length) {
      return null;
    }

    return <TrustpilotWithReviewsPanel customerReviewsContent={content} />;
  }

  return (
    <TrustpilotPanel
      key={id}
      header={header}
      headerAlignment={headerAlignment}
      noPaddingBottom={noPaddingBottom}
    />
  );
};
